module.exports = __webpack_public_path__ + "static/media/sendgrid.c8000b30.svg";